module.exports = __webpack_public_path__ + "static/media/crs.ea8324e3.png";